import { PolicyTypeEnum } from '../enums/policy-type.enum';
import { PolicyConfig } from '../types/policy-config.types';

/**
 * Create policy DTO
 */
export class CreatePolicyDto {
	type!: PolicyTypeEnum;
	name?: string | null;
	config!: PolicyConfig;
	notes?: string | null;
}
